import React, { useState } from 'react';
import ReusableTabs from '../../pages/ReusableTabs';
import PdiReviewTpi from './PdiReviewTpi/PdiReviewTpi';
import MsplApprovals from './MsplApprovals';
import DocumentSection from './SupportedDocuments';

const PdiTabsComponent = () => {
  const [activeTab, setActiveTab] = useState(0); 

  const tabs = [
    { label: 'PDI REVIEW-TPI', component: <PdiReviewTpi /> },
    { label: 'MSPL Approvals', component: <MsplApprovals /> }, 
    { label: 'Supported Documents', component: <DocumentSection /> },
  ];

  return (
    <ReusableTabs
      tabs={tabs}
      defaultTab={0}
      activeTab={activeTab}        
      onTabChange={setActiveTab}   
      panelStyles={{ padding: '16px' }}
    />
  );
};

export default PdiTabsComponent;